import { FC } from "react";
import { useForm } from "react-hook-form";
import {
  IGetBranchOutput,
  IUpdateBranchInput,
} from "../../../../../api-schema/branch";
import { useUpdateBranch } from "../../../repository/branch/update";
import orgRound from "../../../utils/round";
import useBID from "../../../utils/useBid";
import InputWithLabel from "./InputWithLabel";

type Props = {
  branch: IGetBranchOutput;
};
const SettingForm: FC<Props> = ({ branch }) => {
  const bId = useBID();
  const {
    mutate,
    isLoading: isSending,
    isError: isPutError,
    isSuccess,
  } = useUpdateBranch(bId);

  const onSubmit = (value: Omit<Required<IUpdateBranchInput>, "bId">) => {
    if (
      Number(value.lotteryDiscountRate) +
        Number(value.questionnaireDiscountRate) >
      100
    ) {
      alert("抽選割引率とアンケート割引率の合計が 100% を超えています。");
      return;
    }
    mutate({
      lotteryDiscountRate: Number(value.lotteryDiscountRate) / 100,
      lotteryProbability: Number(value.lotteryProbability) / 100,
      questionnaireDiscountRate: Number(value.questionnaireDiscountRate) / 100,
    });
  };

  const {
    register,
    handleSubmit,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <InputWithLabel
        title="当選確率"
        inputElem={
          <input
            className="input"
            type="number"
            step="0.001"
            {...register("lotteryProbability", {
              value: orgRound(branch.lotteryProbability * 100, 2),
              max: 100,
              min: 0,
            })}
            // FIXME 切り出す
            onChange={(e) => {
              const value = Number(e.target.value);
              if (value > 100 || value < 0) {
                setError("lotteryProbability", {
                  type: "value",
                  message:
                    "当選確率は0から100の範囲で半角数字で入力してください。",
                });
              } else {
                clearErrors("lotteryProbability");
              }
            }}
          />
        }
        errorMessage={errors?.lotteryProbability?.message}
        help="星評価後の抽選の当選率を設定できます。例: 0.5, 10"
      />
      <InputWithLabel
        title="抽選 割引率"
        inputElem={
          <input
            className="input"
            type="number"
            step="0.001"
            {...register("lotteryDiscountRate", {
              value: orgRound(branch.lotteryDiscountRate * 100, 2),
              max: 100,
              min: 0,
            })}
            onChange={(e) => {
              const value = Number(e.target.value);
              if (value > 100 || value < 0) {
                setError("lotteryDiscountRate", {
                  type: "value",
                  message:
                    "抽選割引率は0から100の範囲で半角数字で入力してください。",
                });
              } else {
                clearErrors("lotteryDiscountRate");
              }
            }}
          />
        }
        help="抽選に当たったときの割引率です。"
        errorMessage={errors?.lotteryDiscountRate?.message}
      />
      <InputWithLabel
        title="アンケート回答 割引率"
        inputElem={
          <input
            className="input"
            type="number"
            step="0.001"
            {...register("questionnaireDiscountRate", {
              value: orgRound(branch.questionnaireDiscountRate * 100, 2),
              max: 100,
              min: 0,
            })}
            onChange={(e) => {
              const value = Number(e.target.value);
              if (value > 100 || value < 0) {
                setError("questionnaireDiscountRate", {
                  type: "value",
                  message:
                    "アンケート回答 割引率は0から100の範囲で半角数字で入力してください。",
                });
              } else {
                clearErrors("questionnaireDiscountRate");
              }
            }}
          />
        }
        help="アンケートに回答してくれたすべての方に付与される割引率です。<br/>抽選にあたった場合は抽選割引率と加算されます。"
        errorMessage={errors?.questionnaireDiscountRate?.message}
      />
      <button className="is-success button">反映する</button>
      {isSending && <p>更新中</p>}
      {isPutError && <p>更新に失敗しました。</p>}
      {isSuccess && <p>更新に成功しました。</p>}
    </form>
  );
};

export default SettingForm;
